// 按当前 i18n 语言从 { en, zh, ... } 这样的 map 中挑出最合适的文本。
// 优先级：精确匹配（zh-CN）→ 基础语言（zh）→ 英文 → 任意非空 → fallback。
export function pickLocalized(
  fallback: string,
  map: Record<string, string> | null | undefined,
  language: string | undefined,
): string {
  if (!map) return fallback;
  const lang = (language || '').toLowerCase();
  const base = lang.split(/[-_]/)[0];
  const direct = map[lang] ?? map[base];
  if (direct && direct.length > 0) return direct;
  if (map.en && map.en.length > 0) return map.en;
  const firstNonEmpty = Object.values(map).find((v) => typeof v === 'string' && v.length > 0);
  return firstNonEmpty ?? fallback;
}

// 同 pickLocalized，但保留 null 语义（用于 label / description 这种本身可空的字段）。
export function pickLocalizedNullable(
  fallback: string | null | undefined,
  map: Record<string, string> | null | undefined,
  language: string | undefined,
): string | null {
  const picked = pickLocalized(fallback ?? '', map, language);
  return picked.length > 0 ? picked : null;
}
